<script setup>
import ColorMode from '@/components/ColorMode.vue'
</script>

<template>
    <ColorMode />
  <slot name="main" />
</template>

<style scoped>

</style>
